module.exports = __webpack_public_path__ + "img/mission.0088b406.png";